import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Snackbar, SnackbarContent } from '@material-ui/core';
import {
  CheckCircleOutline,
  Close,
  ErrorOutline,
  InfoOutlined,
  ReportProblemOutlined,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  snackbarSuccess: {
    backgroundColor: theme.palette.success.main,
  },
  snackbarError: {
    backgroundColor: theme.palette.error.main,
  },
  snackbarWarning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },
  snackbarInfo: {
    backgroundColor: theme.palette.info.main,
  },
  snackbarNeutral: {
    backgroundColor: 'transparent',
  },
  snackbarMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    fontSize: 20,
  },
}));

const CustomSnackbar = ({ open, onClose, message, severity = 'success' }) => {
  const classes = useStyles();

  const getSnackbarClass = (severity) => {
    switch (severity) {
      case 'success':
        return classes.snackbarSuccess;
      case 'error':
        return classes.snackbarError;
      case 'warning':
        return classes.snackbarWarning;
      case 'info':
        return classes.snackbarInfo;
      default:
        return classes.snackbarNeutral;
    }
  };

  const getIcon = (severity) => {
    switch (severity) {
      case 'success':
        return <CheckCircleOutline className={classes.icon} />;
      case 'error':
        return <ErrorOutline className={classes.icon} />;
      case 'warning':
        return <ReportProblemOutlined className={classes.icon} />;
      case 'info':
        return <InfoOutlined className={classes.icon} />;
      default:
        return null;
    }
  };

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={4000}
    >
      <SnackbarContent
        className={getSnackbarClass(severity)}
        message={
          <span className={classes.snackbarMessage}>
            {getIcon(severity)}
            {message}
          </span>
        }
        action={
          <IconButton
            size="small"
            onClick={onClose}
            color="inherit"
            aria-label="Chiudi"
          >
            <Close fontSize="small" />
          </IconButton>
        }
      />
    </Snackbar>
  );
};

CustomSnackbar.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  severity: PropTypes.string,
};

export default CustomSnackbar;
